import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <StyledFooter className="footer">
      <div className="container">
        <div className="footer_row">
          <div className="footer_column">
            <p>UMA Esplanadi, Pohjoisesplanadi 39, 00100 Helsinki, Finland</p>
            <p>VAT ID: FI26641607</p>
          </div>
          <div className="footer_column">
            <ul className="footer_list">
              <li>
                <Link to="#">О проекте</Link>
              </li>
              <li>
                <Link to="#">Условия использования</Link>
              </li>
              <li>
                <Link to="#">Политика конфиденциальности</Link>
              </li>
            </ul>
          </div>
          <div className="footer_column">
            <ul className="footer_list">
              <li>
                <Link to="#">Блог</Link>
              </li>
              <li>
                <Link to="#">Рекомендуемые книги</Link>
              </li>
              <li>
                <Link to="#">Матрица компетентности</Link>
              </li>
              <li>
                <Link to="#">
                  Вакансии <span className="bi bi-github"></span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer_column">
            <ul className="footer_list">
              <a href="tel:88001002247">8 800 100 22 47</a>
              <div className="small">Звонок по РФ бесплатный</div>
              <a className="my3" href="tel:+74950852838">
                +7 (495) 085-28-38
              </a>
              <a href="mailto:ivan@ivan.com.ua">ivan@ivan.com.ua</a>
            </ul>
          </div>
        </div>
        <div className="footer_bottom">
          <p>IVAN</p>
          <div className="footer_links">
            <Link to="#" className="footer_link">
              <span className="bi bi-facebook text-white-50"></span>
            </Link>
            <Link to="#" className="footer_link">
              <span className="bi bi-telegram text-white-50"></span>
            </Link>
            <Link to="#" className="footer_link">
              <span className="bi bi-twitter text-white-50"></span>
            </Link>
            <Link to="#" className="footer_link">
              <span className="bi bi-youtube text-white-50"></span>
            </Link>
            <Link to="#" className="footer_link">
              <span className="bi bi-slack text-white-50"></span>
            </Link>
          </div>
        </div>
      </div>
    </StyledFooter>
  );
}

const StyledFooter = styled.footer`
  &.footer {
    margin-top: 96px;
    background: rgba(33, 37, 41, 1);
    color: #fff;
    line-height: 1.5;
    .container {
      padding: 48px 12px 16px;
    }
  }

  .footer_row {
    margin-bottom: 1rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px;
  }
  .footer_column p {
    margin-bottom: 1rem;
  }
  .footer_bottom > p {
    margin-bottom: 0;
  }
  .footer_list {
    line-height: 2;
    display: flex;
    flex-direction: column;
  }
  .footer_list .small {
    line-height: 1;
    color: #6c757d;
    font-size: 14px;
  }
  .footer_column:last-child .footer_list {
    line-height: 1.5;
  }
  .footer_bottom {
    padding-top: 1rem;
    border-top: 1px solid #565a5d;
    display: flex;
    align-items: center;
  }
  .footer_links {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
  .footer_link {
    font-size: 1.75rem;
  }
  .footer_link:not(:last-child) {
    margin-right: 48px;
  }
  .footer_list a {
    color: #fff !important;
  }

  @media (max-width: 1191px) {
    &.footer .container {
      max-width: 100%;
    }
    .footer_row {
      margin-bottom: 2rem;
    }
  }

  @media (max-width: 991px) {
    .footer_row {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media screen and (max-width: 567px) {
    .footer_row {
      grid-template-columns: 1fr;
    }
    .footer_link {
      font-size: calc(1.3rem + 0.6vw);
    }
    .footer_link:not(:last-child) {
      margin-right: 16px;
    }
  }
`;
